import classNames from 'classnames';
import React from 'react';
import IFieldRender from '../../types/FieldRender';
import Field from '../Field/Field';
import FieldFooter from '../FieldFooter/FieldFooter';
import TextField from '../TextField/TextField';
import ITextFormFieldProps from './TextFormFieldProps';

const TextFormField = <FormType extends { [field: string]: any } = {}>({
  form,
  name,
  validations,
  className,
  shouldValidateOnUpdate,
  onChange,
  ...other
}: ITextFormFieldProps<FormType>) => {
  function renderField(fieldRender: IFieldRender<string>) {
    const value = form.state.data[name];

    function handleOnChange(val: string) {
      fieldRender.handleChange(val, onChange);
    }

    return (
      <>
        <TextField error={fieldRender.hasError} value={value} onChange={handleOnChange} {...other} />
        <FieldFooter errorMessage={fieldRender.errorMessage} hasError={fieldRender.hasError} />
      </>
    );
  }

  return (
    <Field
      form={form}
      name={name}
      shouldValidateOnUpdate={shouldValidateOnUpdate}
      validations={validations}
      className={classNames('text-form-field', className)}
      defaultValue=""
      render={renderField}
    />
  );
};

export default TextFormField;
